import React from 'react';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import {
  Element,
  Align,
  Color,
  FontType,
  Typography,
  Icon,
  AccordionList
} from '@americanexpress/aqx-components';
import clsx from 'clsx';

export const FAQ = ({ content: faqContent, styles }) => {
  if (!faqContent) {
    return null;
  }
  const { header, description, content, bodyComponent } = faqContent || {};

  return (
    <div className={styles.faqwrap}>
      <Typography
        Component="h2"
        className={styles.header}
        theme={{
          color: Color.Black
        }}
      >
        {header}
      </Typography>
      {description && (
        <Typography
          $size={16}
          className={styles.description}
          $family={FontType.HelveticaRegular}
          theme={{
            textAlign: Align.Left,
            color: Color.Gray05,
            paddingTop: '25px',
            lineHeight: '23px'
          }}
        >
          {description}
        </Typography>
      )}
      <AccordionList
        $openMultiple={true}
        items={(content || []).map((c, index) => ({
          // eslint-disable-next-line react/display-name
          Button: ({ onClick, active }) => (
            <Element
              onClick={() => {
                onClick();
                const currentDtm = active
                  ? faqContent?.faqCollapseDTM ?? null
                  : faqContent?.faqClickDTM ?? null;
                if (currentDtm === null) return;
                const strToReplace = c.faqKey ? '{{faqKey}}' : '{{index}}';
                const replaceWith = c.faqKey ? c.faqKey : index + 1;
                const dtmClick = {
                  ...currentDtm,
                  eventAsset: (currentDtm?.eventAsset || '').replace(
                    strToReplace,
                    replaceWith
                  )
                };

                //Analytics wants the indexing to start at 1 not 0
                sendDTMClickEvent(dtmClick);
              }}
              Component="button"
              type="button"
              active={active.toString()}
              aria-expanded={active}
              className={clsx(styles.button, {
                [styles.active]: active
              })}
              theme={{
                paddingTop: 15,
                paddingBottom: 15,
                paddingRight: 20
              }}
            >
              <Element className={styles.buttonText}>
                <Element
                  className={styles.label}
                  Component="h3"
                  theme={{
                    textAlign: Align.Left,
                    textBody: 3
                  }}
                >
                  {c.title}
                </Element>
              </Element>
              <Icon
                directory="us-consumer"
                hiddenToScreenReaders={true}
                className={styles.iconStyles}
                imageName={active ? 'axp-icon-minuscircle' : 'axp-icon-pluscircle'}
              />
            </Element>
          ),
          // eslint-disable-next-line react/display-name
          Body: () => (
            <Element
              Component={bodyComponent ? bodyComponent : 'h4'}
              className={styles.answer}
            >
              {c.content}
            </Element>
          )
        }))}
      />
    </div>
  );
};
